import Chartist from 'chartist';
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import React, { useEffect } from 'react';
import 'chartist/dist/chartist.min.css';

export type ChartItems = Array<{ meta: string; value: number } | 0>;

type Props = {
    dataset: ChartItems;
    elementId: string;
    isLoading: boolean;
};

function TrendChart({ dataset, elementId, isLoading }: Props) {
    function drawTrendChart() {
        const displayPoint = (value) => value > 0;

        const chart = new Chartist.Line(
            `#${elementId}`,
            {
                labels: dataset,
                series: [dataset],
            },
            {
                showPoint: true,
                showLine: true,
                showArea: false,
                fullWidth: true,
                showLabel: false,
                axisX: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0,
                },
                axisY: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0,
                },
                chartPadding: 0,
                low: 0,
                lineSmooth: Chartist.Interpolation.none(),
                plugins: [ChartistTooltip()],
            }
        );

        chart.on('draw', function (ctx) {
            if (ctx.type === 'point' && !displayPoint(ctx.value.y)) {
                ctx.element.remove();
            }
        });

        chart.on('created', function (ctx) {
            const defs = ctx.svg.elem('defs');
            defs.elem('linearGradient', {
                id: 'gradient',
                x1: 0,
                y1: 2,
                x2: 0,
                y2: 0,
            })
                .elem('stop', {
                    offset: 0,
                    'stop-color': 'rgba(255, 255, 255, 1)',
                })
                .parent()
                .elem('stop', {
                    offset: 1,
                    'stop-color': 'rgba(64, 196, 255, 1)',
                });
        });
    }

    useEffect(() => {
        if (!isLoading) {
            drawTrendChart();
        }
    }, [dataset, isLoading]);

    return <div className="trend-chart" id={elementId} />;
}

export default TrendChart;
